<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>Datascoring</span>

    <div class="example-spacer"></div>

    <button mat-button [matMenuTriggerFor]="beforeMenu" appPermissionControl="P090B0001">{{ usser | slice : 0 : 10 }}... <mat-icon>expand_more</mat-icon></button>
    <mat-menu #beforeMenu="matMenu" xPosition="before">
      <button mat-menu-item (click)="logout()" appPermissionControl="P090B0002"><mat-icon>exit_to_app</mat-icon> Salir</button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>

<div class="container">
  <div class="row">
    <div class="col-sm-3" *ngFor="let item of jsonModules" style="flex: 0 0 auto; width: 50%; padding: 10px">
      <mat-card>
        <h2>{{ item.displayName }}</h2>
        <h2><img src="{{ item.iconName }}" alt /></h2>
        <button class="btn" routerLink="{{ item.url }}" value="Navegar" appPermissionControl="P090B0003">Navegar</button>
      </mat-card>
    </div>
  </div>
</div>
